import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Container from './Container';

const Intro = ({ className, title, titleClassName, text, button, ...props }) => (
  <div className={classNames('intro', className)} {...props}>
    <Container className="intro__container">
      <div className="intro__left">
        <h1
          className={classNames(
            'intro__title',
            titleClassName,
          )}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {text && (
          <p
            className="intro__text"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {button && cloneElement(button, {
          className: 'intro__button',
        })}
      </div>
    </Container>
  </div>
);

Intro.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  text: PropTypes.string,
  button: PropTypes.element,
};

export default Intro;
